import { Global, css } from '@emotion/react'
import React, { useEffect, useRef, useState } from 'react'
import useOnScroll from '../../hooks/useOnScroll'
import * as Styled from './CtaBar.styles' // eslint-disable-line

const CtaBar = ({
  backgroundColor = null,
  leftBlock = null,
  leftDivider = false,
  middleBlock = null,
  middleDivider = false,
  rightBlock = null,
  sticky = false,
  textColor = null,
  ...props
}) => {
  const { scrollRef, scrolledTo } = useOnScroll()

  const stickyBarRef = useRef()
  const [stickyBarHeight, setStickyBarHeight] = useState(80)

  useEffect(() => {
    const handleResize = () => {
      if (stickyBarRef.current) {
        setStickyBarHeight(stickyBarRef.current.clientHeight)
      }
    }

    handleResize()

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [sticky, stickyBarRef])

  return (
    <div>
      <Global
        styles={css`
          body {
            margin-bottom: ${stickyBarHeight}px;
          }
        `}
      />
      <Styled.Container
        className="leshen-cta-bar"
        backgroundColor={backgroundColor}
        textColor={textColor}
        {...props}
      >
        {leftBlock && leftBlock}
        {leftDivider && <Styled.Divider textColor={textColor} />}
        {middleBlock && middleBlock}
        {middleDivider && <Styled.Divider textColor={textColor} />}
        {rightBlock && rightBlock}
      </Styled.Container>
      {sticky && (
        <>
          <div id="sticky-ref" ref={scrollRef} />
          <Styled.Container
            className="leshen-cta-bar sticky"
            ref={stickyBarRef}
            id="sticky-bar"
            isVisible={scrolledTo}
            backgroundColor={backgroundColor}
            textColor={textColor}
            {...props}
          >
            {leftBlock && leftBlock}
            {leftDivider && <Styled.Divider textColor={textColor} />}
            {middleBlock && middleBlock}
            {middleDivider && <Styled.Divider textColor={textColor} />}
            {rightBlock && rightBlock}
          </Styled.Container>
        </>
      )}
    </div>
  )
}

export default CtaBar
